import { render, staticRenderFns } from "./TaskViewMembersPopup.vue?vue&type=template&id=4c37bf32&scoped=true&lang=pug&"
import script from "./TaskViewMembersPopup.vue?vue&type=script&lang=js&"
export * from "./TaskViewMembersPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskViewMembersPopup.vue?vue&type=style&index=0&id=4c37bf32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37bf32",
  null
  
)

export default component.exports